<template>
  <v-card>
    <app-menu :menus="menus" :homeUrl="homeUrl"></app-menu>
    <router-view name="content" class="container-principal"></router-view>
  </v-card>
</template>

<script>
import Footer from '../shared/UserFooter.vue';
// import Navbar from '../shared/UserNavbar.vue';
import MenuModel from '../../models/Menu.js';
import Menu from '../shared/Menu.vue';

export default {
  data: function() {
    return {
      homeUrl: '/support/veiculos',
    };
  },
  computed: {
    menus() {
      return [
        // new MenuModel("Veículos", "nc-icon nc-bus-front-12", "support-vehicle"),
        // new MenuModel('Pedidos', "nc-icon nc-notes", 'support-vehicle-request'),
        new MenuModel('Dashboard', 'dashboard', 'support-dashboard'),
        new MenuModel(
          'Manutenção',
          'nc-icon nc-settings-tool-66',
          'support-maintenance'
        ),
        new MenuModel('Contato ADM', 'supervisor_account', 'adm-contact'),
      ];
    },
  },

  components: {
    'app-footer': Footer,
    // 'app-nav': Navbar,
    'app-menu': Menu,
  },
};
</script>
